export class FormElementHelper {

    public static validateEmail(email: string): boolean {

        if (!email) {

            // No validation
            return true;
        }

        return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(email);
    }

    public static validateTelephoneNumber(telephoneNumber: string): boolean {

        if (telephoneNumber === null || telephoneNumber === '') {

            // No validation
            return true;
        }

        return /^\+([1-9]{1}[0-9]{1}?).(\d{5,})$/.test(telephoneNumber);
    }

    public static validatePersonalIdentifierNumber(personalIdentityNumber: string): boolean {

        if (personalIdentityNumber === null || personalIdentityNumber === '') {

            // No validation
            return true;
        }

        const personalIdentifierNumberValidationRegex = /^(19|20)[0-9]{2}((0[0-9])|(10|11|12))(([0-2][0-9])|(3[0-1])|(([7-8][0-9])|(6[1-9])|(9[0-1])))[0-9]{4}$/;

        const onlyDigits = personalIdentityNumber.replace(/[^0-9]/g, '');

        return personalIdentifierNumberValidationRegex.test(onlyDigits);
    }

    public static tryParseTelephoneNumber(telephoneNumber: string): string {

        if (telephoneNumber === null || telephoneNumber.length  < 3) {

            return telephoneNumber;
        }

        // We want to prevent converting to Swedish country code if he first char already are an +-sign
        const firstCharacter = telephoneNumber.substring(0, 1);

        const parsedFirstNumber = parseInt(telephoneNumber.substring(0, 3), 10);

        const supportedSwedishNbr = [70, 72, 73, 76, 79];

        if (!isNaN(parsedFirstNumber) && supportedSwedishNbr.includes(parsedFirstNumber) && firstCharacter !== '+') {
            telephoneNumber = '+46' + telephoneNumber.substring(1);
        }

        if (telephoneNumber.substring(0, 2) === '00') {

            telephoneNumber = '+' + telephoneNumber.substring(2);
        }

        return telephoneNumber;
    }
}